<template>
  <div
    v-bind:class="{ 'layout-button': true, 'layout-button--active': isActive }"
    @click="onClick"
  >
    <div class="layout-button__icon">
      <LottieIcon src="/static/card.json" v-if="type === 'tile'" />
      <LottieIcon
        src="/static/sidebar.json"
        v-if="type === 'sidebar'"
      />
      <LottieIcon
        src="/static/classic.json"
        v-if="type === 'classic'"
      />
    </div>
    <div v-if="isActive" class="layout-button__active-icon">
      <ActiveBasicLayoutIcon v-if="type === 'tile'" />
      <ActiveSidebarLayoutIcon v-if="type === 'sidebar'" />
      <ActiveTableLayoutIcon v-if="type === 'classic'" />
    </div>
    <div class="layout-name">{{ label }}</div>
  </div>
</template>

<script>
import LottieIcon from "./icons/LottieIcon";
import ActiveBasicLayoutIcon from "./icons/ActiveBasicLayoutIcon";
import ActiveSidebarLayoutIcon from "./icons/ActiveSidebarLayoutIcon";
import ActiveTableLayoutIcon from "./icons/ActiveTableLayoutIcon";

export default {
  name: "layoutItem",
  props: { label: String, type: String, isActive: Boolean, onClick: Function },
  components: {
    LottieIcon,
    ActiveBasicLayoutIcon,
    ActiveSidebarLayoutIcon,
    ActiveTableLayoutIcon
  }
};
</script>

<style>
.layout-name {
  font-size: 10px;
  font-weight: bold;
  color: #1e313a;
  text-align: center;
  margin-top: 8px;
}
.layout-button {
  text-decoration: none;
  padding: 24px 16px 12px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.layout-button.layout-button--active {
  background: white;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.05);
}

.layout-button.layout-button--active .layout-button__icon {
  visibility: hidden;
}

.layout-button svg {
  cursor: pointer;
}
.layout-button.layout-button--active {
  cursor: default;
  pointer-events: none;
}
.layout-button path,
.layout-button rect {
  fill: rgba(74, 74, 74, 0.2);
  transition: fill 0.5s;
}
.layout-button.router-link-active path,
.layout-button.router-link-active rect {
  fill: #0821ff;
}
.layout-button__active-icon {
  position: absolute;
}

@media (max-width: 600px) {
  .layout-button {
    margin: 0;
    padding-left: 7px;
    padding-right: 7px;
  }
}
@media (max-width: 374px) {
  .layout-button {
    padding-left: 4px;
    padding-right: 4px;
  }
}
@media (hover: hover) {
  .layout-button:hover {
    background: white;
  }
  .layout-button:not(.router-link-active):hover path,
  .layout-button:not(.router-link-active):hover rect {
    fill: rgba(8, 33, 255, 0.3);
  }
}
</style>
